import { type FC } from "react";

import { type TooltipContentProps } from "recharts";

import { formatMilliUsd } from "../../../../lens-creator-payout/utils/formatMilliUsd";

import { type MonthlyPayoutDataPoint } from "./MonthlyPayoutsChart";
import { tooltipAmount, tooltipContainer, tooltipHeader } from "./MonthlyPayoutsTooltip.module.css";

const isMonthlyPayoutDataPoint = (value: unknown): value is MonthlyPayoutDataPoint =>
    typeof value === "object" && value !== null && "label" in value && "amountMilliUsd" in value;

export const MonthlyPayoutsTooltip: FC<TooltipContentProps> = ({ active, payload }) => {
    const firstEntry = payload[0];

    if (!active || !firstEntry || !isMonthlyPayoutDataPoint(firstEntry.payload)) {
        return null;
    }

    return (
        <div className={tooltipContainer} role="dialog" aria-hidden={active}>
            <div className={`${tooltipHeader} paragraph-p200`}>{firstEntry.payload.label}</div>
            <div className={`${tooltipAmount} paragraph-p300`}>{formatMilliUsd(firstEntry.payload.amountMilliUsd)}</div>
        </div>
    );
};
